"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TabsContext = require("./TabsContext");
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _carousel = require("@ingka/carousel");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const getFirstPanelId = tabs => {
  const firstTab = tabs.find(tab => tab.props && !tab.props.disabled);
  if (firstTab && firstTab.props) return firstTab.props.tabPanelId;
};
const Tabs = props => {
  const {
    prefix = '',
    overflowCarouselProps,
    slideIndex,
    onTabChanged,
    rtl,
    defaultActiveTab,
    tabs,
    tabPanels,
    className,
    tabDescription,
    activeTab,
    ...otherProps
  } = props;
  const classes = (0, _classnames.default)(`${prefix}tabs`, className);
  const root = (0, _react.useRef)({});
  const [_activeTab, setActiveTab] = (0, _react.useState)(defaultActiveTab || activeTab || getFirstPanelId(tabs));
  const handleTabChange = tabId => {
    if (onTabChanged) onTabChanged(tabId);
    setActiveTab(tabId);
    const activeDTab = (0, _utils.getDTabFromId)(tabId);
    if (!activeDTab) return;
    const container = activeDTab.parentElement;
    if (!container) return;
    const {
      offsetLeft,
      clientWidth
    } = activeDTab;
    const {
      scrollLeft,
      offsetWidth
    } = container;
    if (offsetLeft < scrollLeft || offsetLeft + clientWidth > scrollLeft + offsetWidth) container.scrollTo({
        left: activeDTab.offsetLeft - (rtl ? offsetWidth - clientWidth : 0),
        behavior: 'smooth'
      });
  };
  (0, _react.useEffect)(() => {
    if (activeTab && activeTab !== _activeTab) handleTabChange(activeTab);
  }, [activeTab, tabs, onTabChanged]);
  return _react.default.createElement(_TabsContext.TabProvider, {
    value: {
      activeTab: activeTab || _activeTab,
      setActiveTab: handleTabChange,
      tabs,
      root
    }
  }, _react.default.createElement("div", _extends({}, otherProps, {
    className: classes,
    "aria-label": tabDescription,
    ref: c => root.current = c
  }), _react.default.createElement("div", {
    role: "tablist",
    className: `${prefix}tabs__list`
  }, _react.default.createElement(_carousel.OverflowCarousel, _extends({
    slideIndex: slideIndex,
    rtl: rtl,
    children: tabs,
    prefix: prefix
  }, overflowCarouselProps))), tabPanels));
};
var _default = Tabs;
exports.default = _default;